/**
 * SA-1079: the Inbox conversation list's width limits. The list and the
 * message chain share a draggable edge; the LIST is the column with a
 * width (the chain stays `flex-1`), stored per viewer as
 * `ui.inboxListWidth` (null = the default). The rule itself is every
 * panel's (`components/ui/panelWidth`, SA-813). 288 is the UX pass's wider
 * default for the chain (the list was a fixed 320).
 */
import { storedWidth } from '@/components/ui/panelWidth'

export const LIST_WIDTH = { default: 288, min: 224, max: 480 } as const

/** The width to draw for a stored value (`panelWidth.storedWidth`). */
export function listWidth(stored: unknown): number {
  return storedWidth(stored, LIST_WIDTH)
}
